import {DateTime} from "luxon";

export const formatDate = (date: string, language: any) => {
    const dt = DateTime.fromISO(date);
    return dt.isValid ? dt.toFormat(language.dateFormat) : '';
}